(ns ui.gallery.tabs
  "The tab bar of the Replicant gallery to either show the active or the
   archived story medias.")

(def tabs
  [{:mode :active
    :label "Gallery"
    :icon [:i.far.fa-images]}
   {:mode :archive
    :label "Archive"
    :icon [:i.fas.fa-archive]}])

(defn tab
  [active-mode {:keys [mode label icon]}]
  (let [active? (= mode active-mode)]
    [:span.cursor-pointer.py-2.px-1.text-center.border-b-2.sm:w-72
     {:replicant/key label
      :class (concat ["w-1/2"]
                     (if active?
                       ["border-secondary-500" "text-secondary-600"]
                       ["border-transparent" "text-gray-500"
                        "hover:text-gray-700" "hover:border-gray-400"]))
      :aria-current (when active? "page")
      :on {:click [[:gallery/set-mode mode]]}}
     icon
     [:span.ml-1 label]]))

(defn tab-bar
  [active-mode]
  [:nav.-mb-px.flex.w-full.justify-center.border-b.border-gray-300
   {:aria-label "Tabs"}
   (map (partial tab active-mode)
        tabs)])
